module.exports = __webpack_public_path__ + "static/img/guide_img_3.7394ed50.jpg";